import { fetch } from '@atlassian/eoc-fetch';
export const getMaintenance = teamId => {
  return fetch(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances`);
};
export const deleteMaintenance = (teamId, id) => {
  return fetch(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}`, {
    method: 'DELETE',
    responseType: 'headers'
  });
};
export const cancelMaintenance = (teamId, id) => {
  return fetch(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/cancel`, {
    method: 'PATCH'
  });
};
export const changeDateAndTime = (teamId, id, endDate) => {
  return fetch(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/updateEndDate`, {
    method: 'PATCH',
    body: {
      endDate
    }
  });
};
export const getMaintenanceUserRights = teamId => {
  return fetch(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/rights`);
};
export const createMaintenance = (payload, teamId) => {
  const url = teamId ? `/v1/teams/${teamId}/maintenances` : '/v1/maintenances';
  return fetch(url, {
    method: 'POST',
    body: payload
  });
};
export const updateMaintenance = (payload, id, teamId) => {
  const url = teamId ? `/v1/teams/${teamId}/maintenances/${id}` : `/v1/maintenances/${id}`;
  return fetch(url, {
    method: 'PUT',
    body: payload
  });
};